// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__8xwgc","active":"NavigationItem_active__dcXJ7"};